import { render, staticRenderFns } from "./order-evaluate.vue?vue&type=template&id=1772dd67&scoped=true&"
import script from "./order-evaluate.vue?vue&type=script&lang=js&"
export * from "./order-evaluate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1772dd67",
  null
  
)

export default component.exports